<template>
  <el-form-item
    :label="titlize(label)"
    :rules="metaData.is_required ? requiredField() : []"
  >
    <el-select
      class="authx-select-field"
      :ref="`input-field-${formIndex}`"
      v-model="optionValue"
      @focus="changeColor($event)"
      @blur="resetColor($event)"
      @change="validateInput"
      clearable
      :disabled="preview"
    >
      <el-option
        v-for="(option, i) in options"
        :key="i"
        :label="titlize(option)"
        :value="option"
      ></el-option>
    </el-select>

    <div class="el-form-item__error">
      {{ errMsg }}
    </div>
  </el-form-item>
</template>

<script>
import { titleCase } from "@/lib/utils";

export default {
  name: "Dropdown",
  props: {
    label: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => {
        return [];
      }
    },
    value: {
      type: String,
      default: ""
    },
    metaData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    colors: {
      type: Object,
      default() {
        return {};
      }
    },
    parentForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    formIndex: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      input: "",
      optionValue: "",
      errMsg: ""
    };
  },

  inject: ['preview'],

  computed: {
    setValue: {
      get() {
        return this.optionValue;
      },
      set(value) {
        this.$emit("update:value", value);
      }
    },
    preview() {
      return this.preview
    }
  },

  methods: {
    validateInput() {
      if (!this.metaData.is_required && !this.optionValue) {
        return;
      }

      if (this.metaData.is_required && !this.optionValue) {
        this.errMsg = `${this.titlize(this.label)} is required`;
        this.$emit("isValid", false);
      } else {
        this.errMsg = "";
      }
    },

    changeColor(evt) {
      evt.target.style.borderColor = this.colors.secondary;
    },

    resetColor(evt) {
      this.validateInput();
      evt.target.style.borderColor = "#dcdfe6";
    },

    titlize(option) {
      return titleCase(option);
    }
  },
  watch: {
    optionValue(val) {
      this.setValue = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-scrollbar {
  overflow-y: scroll;
}
</style>
